import React, { useEffect, useState } from "react";
import { checkValidity } from "../../shared/utility";
import Input from '../../UI/Input/Input';
import "./UserSearchBlock.css"

const UserSearchBlock = (props) => {

    const [formInputElements, setFormInputElements] = useState({
        firstName:{
            elementType: 'input',
            elementConfig: {
                type: 'text',
                id: 'firstName',
                placeholder: '',
                maxLength: 101,
            },
            value: props.firstName.value,
            validation: {
                required: false,
                minlength: 3,
                maxlength: 100,
                nospace: true
            },
            valid: true,
            label: "First Name",
            inputType: "OneThird",
            disabled: false
        },
        lastName:{
            elementType: 'input',
            elementConfig: {
                type: 'text',
                id: 'lastName',
                placeholder: '',
                maxLength: 101,
            },
            value: props.lastName.value,
            validation: {
                required: false,
                minlength: 3,
                maxlength: 100,
                nospace: true
            },
            valid: true,
            label: "Last Name",
            inputType: "OneThird",
            disabled: false
        },
        dob:{
            elementType: 'input',
            elementConfig: {
                type: 'date',
                id: 'dob',
                placeholder: '99-99-9999',
                min: '01-01-1900',
                max: '30-03-2022'
            },
            value: props.dob.value,
            validation: {
                required: false,
                restrictFuture: true
            },
            valid: true,
            label: "DOB",
            inputType: "OneThird"
        },
    })

    const clearSearch = () => {

        const updatedForm = {...formInputElements}

        updatedForm['firstName'].value = ''
        updatedForm['firstName'].touched = false
        updatedForm['firstName'].valid = true

        updatedForm['lastName'].value = ''
        updatedForm['lastName'].touched = false
        updatedForm['lastName'].valid = true

        updatedForm['dob'].value = ''
        updatedForm['dob'].touched = false
        updatedForm['dob'].valid = true

        setFormInputElements(updatedForm)
    }

    const clearUserSearchForm = () => {
        clearSearch()
        props.setFirstName({value:'', touched: false})
        props.setLastName({value:'', touched: false})
        props.setDOB({value:'', touched: false})
    }

    useEffect(() => {
        if(props.eventSelected === 'Authenticate'){
            clearUserSearchForm()
        }
        if(props.clearSearch){
            props.clearSearch.current = clearUserSearchForm
        }
    },[props.eventSelected])

    // Values seeded from a restored search arrive after the first render.
    useEffect(() => {
        setFormInputElements(currentForm => ({
            ...currentForm,
            firstName: {...currentForm.firstName, value: props.firstName.value},
            lastName: {...currentForm.lastName, value: props.lastName.value},
            dob: {...currentForm.dob, value: props.dob.value}
        }))
    },[props.firstName.value, props.lastName.value, props.dob.value])

    const inputChangedHandler = (event, inputIdentifier) => {

        let updatedForm = {...formInputElements};

        const updatedFormElement = { ...updatedForm[inputIdentifier] };
        updatedFormElement.value = event.target.value;
        if(event.target.value) {
            const validation = checkValidity(updatedFormElement.value, updatedFormElement.validation);
            updatedFormElement.valid = validation.isValid;
            props.errorHandler({message: validation.message});
        } else {
            updatedFormElement.valid = true;
            props.errorHandler(null);
        } 
        updatedForm[inputIdentifier] = updatedFormElement;
        let formIsValid = true;
        for (let inputIdentifier in updatedForm) {
            formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
        }
        if(inputIdentifier === 'firstName'){
            props.setFirstName({value:event.target.value, touched: true})
        }else if(inputIdentifier === 'lastName'){
            props.setLastName({value:event.target.value, touched: true})
        }else{
            props.setDOB({value:event.target.value, touched: true})
        }
        props.setFormIsValid(formIsValid);
        setFormInputElements(updatedForm);
    }

    const createForm = () => {

        const formsElementsArray =[];

        for(let key in formInputElements) {
            formsElementsArray.push({
                id: key,
                config: formInputElements[key]
            });
        }
    
        return (
        <>
            <div style={{"display":"flex"}}>
                {formsElementsArray.map((formElement => (
                    <Input
                        key={formElement.id}
                        elementType={formElement.config.elementType}
                        elementConfig={formElement.config.elementConfig}
                        value={formElement.config.value}
                        invalid={!formElement.config.valid}
                        shouldValidate={formElement.config.validation}
                        touched={formElement.config.touched}
                        label={formElement.config.label}
                        changed={(event) => inputChangedHandler(event, formElement.id)}
                        extendedInput={formElement.config.extendedInput}
                        inputType={formElement.config.inputType}
                    />
                )))} 
            </div>
        </>
        )
        
    }

    return <>
        {createForm()}
    </>
}

export default UserSearchBlock;